import BaseModel from './BaseModel';

class CsVersionUpdate extends BaseModel {
  constructor(data = {}) {
    super(data);
    this.updateData(data)
  }

  updateData = (data) => {
    this.version_type = {
      android: 'Software',
      bin: 'Hardware'  
    };
    this.circle_ids = data.circle_ids || [];
    this.city_ids = data.city_ids || [];
    this.charging_zone_ids = data.charging_zone_ids || [];
    this.device_ids = data.device_ids || [];
    this.type = data.type || "";
    this.version = data.version || "";
    this.remarks = data.remarks || "";
  }

  toApiJson = () => {
    this.completeValidation();
    return {
        cs_version_update: {
        device_id: this.device_ids.toString(),
        type: this.version_type[this.type],
        version: this.version,
        username: JSON.parse(localStorage.getItem('auth')).user.name,
        usermail: JSON.parse(localStorage.getItem('auth')).user.email,
        reason: this.remarks
      }
    }
  }

  validations = (field) => {
    return {
      device_ids: () => {
        if (this[field].length === 0) {
          this.errors.device_ids = "Select charging station.";
        } else {
          delete this.errors.device_ids;
        }
      },
      type: () => {
        if (this[field].trim() === "" || this[field].length === 0) {
          this.errors.type = "Select version type.";
        } else {
          delete this.errors.type;
        }
      },
      version: () => {
        if (this[field].trim() === "" || this[field].length === 0) {
          this.errors.version = "Select version.";
        } else if (this.type === 'android' && !this[field].endsWith(".apk")) {
          this.errors.version = `The version name must end with ".apk".`;
        } else if (this.type === 'bin' && !this[field].endsWith(".bin")) {
          this.errors.version = `The version name must end with ".bin".`;
        } else {
          delete this.errors.version;
        }
      },
      remarks: () => {
        if (this[field].trim() === "" || this[field].length === 0) {
          this.errors.remarks = "Please enter remarks/reason for update.";
        } else {
          delete this.errors.remarks;
        }
      },
    }[field];
  }

  validate = (field) => {
    if (this.validations(field)) {
      this.validations(field)();
    }
  }
}

export default CsVersionUpdate;
